// The Calculator decision interface's read: the SAME GET the evidence view makes
// (lib/mackCalculatorEvidence.ts fetchCalculatorEvidence — same route, same headers), then the same
// strict decode; if the decode refuses, the response is still shown as received, with notices
// (lib/mackCalculatorView.js readProjection), so the screen never goes blank while the backend moves.
import axios from 'axios';
import { apiBase, authToken } from '../api/apiBase';
import { CALCULATOR_SHEETS, CALCULATOR_FAMILIES, decodeCalculatorProjection } from './mackCalculatorEvidence';
import { readProjection } from './mackCalculatorView';

export async function readCalculator(token?: string | null): Promise<{ projection: any; notices: string[] }> {
  const response = await axios.get(`${apiBase()}/mack/calculator`, {
    headers: {Authorization: `Bearer ${token || authToken()}`, 'Cache-Control': 'no-cache'},
  });
  return readProjection(response.data, decodeCalculatorProjection, CALCULATOR_SHEETS, CALCULATOR_FAMILIES);
}
